import { useFormContext as useReactHookFormContext } from "react-hook-form";

/**
 *  useFormContext is a custom hook that simply wraps React hook form to allow future features if ever required.
 */

const useFormContext = () => useReactHookFormContext() ?? { formState: {} };

export { useFormContext };
